<div class="card card-accent-success animated fadeIn mt-2">
    <a class="card-header-a" (click)="isCollapsed = !isCollapsed"
       [attr.aria-expanded]="!isCollapsed" aria-controls="collapsed">
        <div class="card-header-buscador">
            <i class="icon-recinto"></i> Superficie de recintos seleccionados
            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
        </div>
    </a>
    <div class="card-body">
            
        <div class="collapse" id="collapse" [ngbCollapse]="isCollapsed">

            <div *ngIf="superficieUI && superficieAcumulada > superficieUI" class="alert alert-danger mt-2" role="alert">
                <span>La superficie de los recintos seleccionados ({{ superficieAcumulada | number:'1.2-5':'es-ES' }} ha), no puede ser superior a la superficie de la Unidad de Inspección ({{ superficieUI | number:'1.2-5':'es-ES' }} ha).</span>
            </div>
            <div class="row mt-2">
                <div class="col-4">
                    <ul>
                        <li *ngIf="superficieUI">Superficie Máxima de la Unidad de Inspección: {{ superficieUI | number:'1.2-5':'es-ES' }}&nbsp;ha</li>
                        <li *ngIf="!superficieUI">Superficie de la Unidad de Inspección (ha): Sin límite</li>
                        <li>Superficie de los recintos seleccionados: {{ superficieAcumulada | number:'1.2-5':'es-ES' }}&nbsp;ha</li>
                        <li>Superficie Disponible: {{ superficieUI - superficieAcumulada | number:'1.2-5':'es-ES' }}&nbsp;ha</li>
                    </ul>
                </div>
                <div class="col-8" *ngIf="superficieUI">
                    <div class="progress">
                        <div [ngClass]="getBgProgress()" class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" attr.aria-valuenow="{{ superficieAcumulada | number:'1.2-5' }}" attr.aria-valuemin="0.0" attr.aria-valuemax="{{ superficieUI  | number:'1.2-2' }}" [ngStyle]="{ 'width': porcentajeCultivado + '%' }" title="{{ (superficieAcumulada | number:'1.2-5':'es-ES') + ' de ' + (superficieUI | number:'1.2-5':'es-ES') + ' ha' }}">{{ porcentajeCultivado }} %</div>
                    </div>
                </div>
                <div class="col-4"> <!-- Div para cuadrar columnas --> </div>
                <div class="col-8 feedback">
                    {{ (superficieAcumulada | number:'1.2-5':'es-ES') + ' de ' + (superficieUI | number:'1.2-5':'es-ES') + ' ha' }}
                </div>
            </div>
        </div>
    </div>
</div>